export default {
      id: "ic_contact_btn-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_contact_btn-usage",
      toString: function () {
        return this.url;
      }
    }